<template>
  <div class="container-fluid">
    <h2>Quarentena Nova Engel</h2>
    <h5>
      Produtos com a catalogação da Nova Engel alterada ou inconsistente. O stock NE fica a zero até
      confirmar a correção.
    </h5>
    <h5 v-if="mode != 'on'">
      Modo: <strong>{{ mode == 'dry' ? 'teste (o stock não é bloqueado)' : 'desligado' }}</strong>
    </h5>
    <b-tabs content-class="mt-3" @activate-tab="onTab">
      <b-tab :title="`Por corrigir (${open.length})`" active>
        <b-table striped hover :items="open" :fields="openFields" thead-class="text-blue" show-empty empty-text="Sem produtos em quarentena">
          <template #cell(sku)="data">
            <b-link v-if="data.item.id_backoffice" :href="`/product/${data.item.id_backoffice}`">{{ data.item.received.sku }}</b-link>
            <span v-else>{{ data.item.received.sku }}</span>
          </template>
          <template #cell(ean)="data">{{ data.item.received.ean }}</template>
          <template #cell(name)="data">
            {{ data.item.received.name }}
            <div v-if="data.item.backoffice_name" class="small text-muted">Backoffice: {{ data.item.backoffice_name }}</div>
          </template>
          <template #cell(changes)="data">
            <div v-for="(change, i) in data.item.changes" :key="i">{{ describe(change) }}</div>
          </template>
          <template #cell(detected_at)="data">
            {{ formatDate(data.item.detected_at) }}
            <div class="small">{{ data.item.days_blocked }} {{ data.item.days_blocked == 1 ? 'dia' : 'dias' }}</div>
          </template>
          <template #cell(buttons)="data">
            <b-button size="sm" variant="success" @click="resolve(data.item, 'corrigido')">Corrigido</b-button>
            <b-button size="sm" variant="warning" @click="resolve(data.item, 'excecao')">Exceção</b-button>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="Histórico">
        <div class="filters">
          <b-form-input type="date" v-model="from" />
          <b-form-input type="date" v-model="to" />
          <b-button variant="primary" @click="getHistory">Filtrar</b-button>
        </div>
        <b-table striped hover small :items="history" :fields="historyFields" thead-class="text-blue" show-empty empty-text="Sem registos">
          <template #cell(sku)="data">
            <b-link v-if="data.item.id_backoffice" :href="`/product/${data.item.id_backoffice}`">{{ data.item.received.sku }}</b-link>
            <span v-else>{{ data.item.received.sku }}</span>
          </template>
          <template #cell(ean)="data">{{ data.item.received.ean }}</template>
          <template #cell(name)="data">{{ data.item.received.name }}</template>
          <template #cell(changes)="data">
            <div v-for="(change, i) in data.item.changes" :key="i">{{ describe(change) }}</div>
          </template>
          <template #cell(detected_at)="data">{{ formatDate(data.item.detected_at) }}</template>
          <template #cell(resolved_at)="data">{{ data.item.resolved_at ? formatDate(data.item.resolved_at) : 'Por corrigir' }}</template>
          <template #cell(resolution)="data">
            {{ data.item.resolution == 'excecao' ? 'Exceção' : data.item.resolution == 'corrigido' ? 'Corrigido' : '' }}
            <div v-if="data.item.note" class="small text-muted">{{ data.item.note }}</div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
const thStyle = 'font-size: 16px ; background-color:rgb(255, 147, 147);vertical-align: middle';
const FIELD_LABEL = { name: 'Nome', sku: 'SKU', ean: 'EAN' };
const RULE_LABEL = {
  ean_em_falta: 'EAN em falta',
  ean_digito_controlo: 'Dígito de controlo do EAN inválido',
  sku_em_falta: 'SKU em falta',
  ean_sku_ultimos5: 'Últimos 5 dígitos do EAN diferentes dos do SKU',
};

export default {
  data: function () {
    return {
      open: [],
      history: [],
      mode: 'off',
      from: null,
      to: null,
      openFields: [
        { key: 'sku', label: 'SKU', tdClass: 'align-middle', thStyle },
        { key: 'ean', label: 'EAN', tdClass: 'align-middle', thStyle },
        { key: 'name', label: 'Nome NE', tdClass: 'align-middle', thStyle },
        { key: 'changes', label: 'O que mudou', tdClass: 'align-middle', thStyle },
        { key: 'detected_at', label: 'Detetado', tdClass: 'align-middle', thStyle },
        { key: 'buttons', label: '', tdClass: 'align-middle', thStyle },
      ],
      historyFields: [
        { key: 'sku', label: 'SKU', thStyle },
        { key: 'ean', label: 'EAN', thStyle },
        { key: 'name', label: 'Nome NE', thStyle },
        { key: 'changes', label: 'O que mudou', thStyle },
        { key: 'detected_at', label: 'Detetado', thStyle },
        { key: 'resolved_at', label: 'Corrigido', thStyle },
        { key: 'resolved_by', label: 'Por', thStyle },
        { key: 'resolution', label: 'Resolução', thStyle },
      ],
    };
  },
  methods: {
    describe(change) {
      if (change.field) return `${FIELD_LABEL[change.field] || change.field}: ${change.old} → ${change.new}`;
      return RULE_LABEL[change.rule] || change.rule;
    },
    formatDate(date) {
      return new Date(date).toLocaleString('pt-PT');
    },
    async getOpen() {
      try {
        const res = await this.$store.dispatch('getNeQuarantine');
        this.open = res.data;
        this.mode = res.mode;
      } catch (err) {
        console.log(err);
        alert(err);
      }
    },
    async getHistory() {
      try {
        const res = await this.$store.dispatch('getNeQuarantineHistory', { from: this.from, to: this.to });
        this.history = res.data;
      } catch (err) {
        console.log(err);
        alert(err);
      }
    },
    onTab(index) {
      if (index == 1) this.getHistory();
    },
    async resolve(item, resolution) {
      const result = await this.$swal({
        title:
          resolution == 'excecao'
            ? 'Marcar como exceção? O produto deixa de ser validado pela regra EAN/SKU.'
            : 'Confirma que o produto foi corrigido?',
        text: `${item.received.sku} - ${item.received.name}`,
        input: 'text',
        inputPlaceholder: 'Nota (opcional)',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      });
      if (!result.isConfirmed) return;
      try {
        await this.$store.dispatch('resolveNeQuarantine', {
          id: item.id,
          resolution: resolution,
          note: result.value || null,
        });
        await this.getOpen();
        this.$swal({
          title: 'Quarentena removida',
          text: 'O stock NE volta na próxima importação.',
          icon: 'success',
        });
      } catch (err) {
        console.log(err);
        this.$swal({ title: 'Erro', text: err.message, icon: 'error' });
      }
    },
  },
  async created() {
    this.getOpen();
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
  margin-top: 5px;
}
h5 {
  text-align: center;
}
.table {
  text-align: center;
}
.btn {
  margin: 2px 5px;
}
.filters {
  display: flex;
  gap: 10px;
  max-width: 500px;
  margin: 0 auto 15px auto;
}
</style>
